<template>
  <b-card>
    <b-button
      variant="primary"
      :disabled="!($can('write', 'release-trip') && showRelease) || releaseBtnLoading"
      @click="release"
    >
      <b-spinner
        v-if="releaseBtnLoading"
        small
      />
      <span v-else>Release</span>
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BSpinner,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import { successNotification, errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BButton,
    BSpinner,
  },
  props: {
    userType: {
      type: String,
      default: '',
    },
    userExternalId: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    const releaseBtnLoading = ref(false)
    const showRelease = computed(() => {
      if (props.userType === 'driver') {
        return ctx.root.$store.getters['driverUsersTrips/driverHasActiveTrip']
      }
      return ctx.root.$store.getters['driverUsersTrips/userHasActiveTrip']
    })
    const release = async () => {
      try {
        releaseBtnLoading.value = true
        await ctx.root.$store.dispatch('trips/releaseTrip', {
          userType: props.userType,
          userExternalId: props.userExternalId,
        })
        successNotification('Released')
      } catch (error) {
        errorNotification('Failed')
        console.log(error)
      } finally {
        releaseBtnLoading.value = false
      }
    }

    return {
      releaseBtnLoading,
      release,
      showRelease,
    }
  },
}
</script>

<style>

</style>
